// Default shape of an inline pet row in the new-customer form. Kept in its own
// module so both the editor component and the form can import it without
// tripping the react-refresh "components only" rule.
export const EMPTY_PET = {
  name: '',
  speciesId: '',
  breedId: '',
  sex: 'unknown',
  birthDate: '',
  weightKg: '',
  allergies: [],
  dietaryNotes: ''
};
